import { parseDate, type ApiHousehold, type ApiProduct, type ProductStatus, type Snapshot } from '@hogar/shared';
import { useSnapshot } from './session';

/** The signed-in owner's house. Screens behind the setup guard can rely on it being there. */
export function useHouse() {
  const { data } = useSnapshot();
  const snap = data as Snapshot & { household: ApiHousehold };
  return { ...snap, todayDate: parseDate(snap.today.date) };
}

const URGENCY: Record<ProductStatus, number> = { out: 0, low: 1, good: 2 };

export function byUrgency(list: ApiProduct[]): ApiProduct[] {
  return [...list].sort((a, b) => URGENCY[a.status] - URGENCY[b.status] || a.order - b.order);
}

/** "Por resurtir" counts both "Se terminó" and "Queda poco". */
export function toRestock(list: ApiProduct[]): ApiProduct[] {
  return byUrgency(list).filter((p) => p.status !== 'good');
}
